import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">Solidly Finance</div>
        <p className="footer-text">
          Chart your path to your financial goals with the ultimate personal finance planning tool.
        </p>
        <div className="footer-badges">
          <span className="footer-badge">Built in Virginia, USA</span>
          <span className="footer-badge">Privacy-first</span>
          <span className="footer-badge">Secure payments by Stripe</span>
        </div>
        <div className="footer-contact">
          <p>Questions? Email us at <a href="mailto:support@solidly.ai">support@solidly.ai</a></p>
        </div>
        <div className="footer-links">
          <Link to="/support">Support</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/releases">Releases</Link>
          <a href="https://try.solidly.ai" target="_blank" rel="noopener noreferrer">Company</a>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2025 SolidlyAI. All rights reserved.</p>
          <div className="footer-disclaimer">
            <p style={{ fontSize: '0.8em', color: '#888', marginTop: '1rem' }}>
              Solidly Finance is a personal finance planning and simulation tool. 
              It does not provide financial, investment, tax, or legal advice. 
              All calculations and projections are for informational and educational purposes only. 
              Actual financial outcomes may vary.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;